import { NgModule } from '@angular/core';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminTechnologyComponent } from './technology/admin-technology.component';
import { AdminPortalComponent } from './portal/admin-portal.component';
import { AdminUsersComponent } from './users/admin-users.component';
import { AdminTechnologyEditorComponent } from './technology/technology-editor/admin-technology-editor.component';
import { AdminTerminologyComponent } from './terminology/admin-terminology.component';
import { AdminTerminologyContainerComponent } from './terminology/admin-terminology-container.component';
import { AdminTermChangesComponent } from './terminology/admin-term-changes.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuillModule } from 'ngx-quill';
import { LightboxComponent } from './lightbox/lightbox.component';
import { SanitizeImgPipe } from './lightbox/sanitizeImg.pipe';
import { AdminServicesComponent } from './services/admin-services.component';
import { AdminStringEditorComponent } from './string-editor/admin-string-editor.component';
import { AdminSLAsComponent } from './slas/admin-slas.component';
import { AdminSuitesComponent } from './suites/admin-suites.component';
import { AdminServicesEditorComponent } from './services/services-editor/admin-services-editor.component';
import { AdminPartnersComponent } from './partners/admin-partners.component';
import { AdminPartnersEditorComponent } from './partners/partners-editor/admin-partners-editor.component';
import { AdminSuitesEditorComponent } from './suites/suites-editor/admin-suites-editor.component';
import { AdminChangeLogComponent } from './individual-change-log/admin-change-log.component';
import { SharedModule } from '../shared/shared.module';
import { CashmereModule } from '../cashmere.module';
import { AdminProductLinesComponent } from './product-lines/admin-product-lines.component';
import { AdminStatusesComponent } from './statuses/admin-statuses.component';
import { AdminTerminologyChangeLogComponent } from './terminology/admin-terminology-change-log.component'
import { AdminFullChangeLogComponent } from './full-change-log/admin-full-change-log.component';
import { AdminDownloadsComponent } from './downloads/admin-downloads.component';
import { AdminSourcesComponent } from './sources/admin-sources.component';
import { AdminSourcesEditorComponent } from './sources/sources-editor/admin-sources-editor.component';
import { AdminFeedbackComponent } from './feedback/admin-feedback.component';
import { AdminKeysComponent } from './keys/admin-keys.component';

@NgModule({
    imports: [ AppRoutingModule, NgSelectModule, QuillModule, CashmereModule, SharedModule, FormsModule, ReactiveFormsModule],
    providers: [],
    declarations: [
        AdminPortalComponent,
        AdminSuitesComponent,
        AdminSuitesEditorComponent,
        AdminTechnologyComponent,
        AdminTechnologyEditorComponent,
        AdminServicesComponent,
        AdminServicesEditorComponent,
        AdminPartnersComponent,
        AdminPartnersEditorComponent,
        AdminChangeLogComponent,
        AdminUsersComponent,
        AdminTerminologyComponent,
        AdminTerminologyContainerComponent,
        AdminTerminologyChangeLogComponent,
        AdminTermChangesComponent,
        LightboxComponent,
        SanitizeImgPipe,
        AdminStringEditorComponent,
        AdminStatusesComponent,
        AdminProductLinesComponent,
        AdminSLAsComponent,
        AdminFullChangeLogComponent,
        AdminDownloadsComponent,
        AdminSourcesComponent,
        AdminSourcesEditorComponent,
        AdminFeedbackComponent,
        AdminKeysComponent
    ]
})
export class AdminModule {}
